export const DATA = [
  {
    id: 0,
    tr: 'hakkında, hemen hemen, yaklaşık',
    en: 'about',
  },
  {
    id: 1,
    tr: 'bütün, tüm, hepsi, her şey',
    en: 'all',
  },
  {
    id: 2,
    tr: 'bir, (herhangi) bir',
    en: 'an',
  },
  {
    id: 3,
    tr: 've, ile anlamında bir bağlaç',
    en: 'and',
  },
  {
    id: 4,
    tr: 'olmak fiilinin üçüncü tekil şahıs hali (they are)',
    en: 'are',
  },
  {
    id: 5,
    tr: 'kadar, olarak, -dikçe, babında (zarf); gibi, için, kadar, karşın, -e rağmen (edat)',
    en: 'as',
  },
  {
    id: 6,
    tr: '-de, -da, -e, -a, üzerinde, saatinde',
    en: 'at',
  },
  {
    id: 7,
    tr: 'olmak, var olmak, bulunmak',
    en: 'be',
  },
  {
    id: 8,
    tr: 'çünkü, zira, dolayı, nedeniyle, -dığı için',
    en: 'because',
  },
  {
    id: 9,
    tr: 'ama, fakat, lakin',
    en: 'but',
  },
  {
    id: 10,
    tr: 'tarafından, -e bakarak, kadar',
    en: 'by',
  },
  {
    id: 11,
    tr: 'çağrı, aramak (fiil)',
    en: 'call',
  },
  {
    id: 12,
    tr: 'yapabilmek, -ebilmek, -abilmek',
    en: 'can',
  },
];
